import { type ProviderResults } from '../../types';
import { isComplete } from '../providers/as-data-provider';

import buildAtlassianHomeSwitcherItemType from './atlassian-home';
import buildAtlassianStartSwitcherItemType from './atlassian-start-product';
import { getHomeUrl } from './get-home-url';
import { type SwitcherItemType } from './links';
import { isFedRamp } from '@atlassian/atl-context';

export const buildAtlassianHomeOrStartSwitcherItemType = (
	orgId: string,
	availableProducts?: ProviderResults['availableProducts'],
): SwitcherItemType => {
	let homeUrl = getHomeUrl(availableProducts) ?? 'https://home.atlassian.com';

	if (availableProducts && isComplete(availableProducts) && availableProducts.data.startUrl) {
		// atlassian home is not available in FedRamp we fallback to atlassian start
		if (isFedRamp()) {
			return buildAtlassianStartSwitcherItemType(availableProducts.data.startUrl);
		}
	}

	// orgID can be empty string and we only pass it if it's not empty
	if (orgId) {
		homeUrl = `${homeUrl}/o/${orgId}`;
	}

	return buildAtlassianHomeSwitcherItemType(homeUrl);
};
